const MIN_CHUNK_SIZE = 1024 * 1024 ; // 1mb
const DEFAULT_CHUNK_SIZE = 1024 * 1024 * 50; // 50mb
const MAX_CHUNK_SIZE = 1024 * 1024 * 128; // 128mb
const DEFAULT_RETRIES = 5;
const DEFAULT_API_HOST = "streaming.hashure.com";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};

                function PromiseQueue() {
                    this.working = false;
                    this.queue = [];
                }
                PromiseQueue.prototype.add = function (provider) {
                    var _this = this;
                    return new Promise(function (resolve, reject) {
                        var entry = {
                            provider: provider,
                            callback: function (res, error) { return error ? reject(error) : resolve(res); }
                        };
                        _this.queue = _this.queue.concat(entry);
                        if (!_this.working) {
                            _this.working = true;
                            _this.dequeue();
                        }
                    });
                };
                PromiseQueue.prototype.dequeue = function () {
                    var _this = this;
                    if (this.queue.length === 0) {
                        this.working = false;
                        return;
                    }
                    ;
                    var current = this.queue.shift();
                    current.provider.call(this).then(function (res) {
                        current.callback(res);
                        _this.dequeue();
                    })["catch"](function (err) {
                        current.callback(undefined, err);
                        _this.dequeue();
                    });
                };

const VideoUploader = function VideoUploader(options) {
                    this.currentChunk = 0;
                    this.onProgressCallbacks = [];
                    this.headers = {};
                    this.queue = new PromiseQueue();
                    var apiHost = options.apiHost || DEFAULT_API_HOST;
                    if (!options.file) {
                        throw new Error("'file' is missing");
                    }
                    if (options.hasOwnProperty("uploadToken")) {
                        var optionsWithUploadToken = options;
                        if (optionsWithUploadToken.videoId) {
                            this.videoId = optionsWithUploadToken.videoId;
                        }
                        this.uploadEndpoint = "https://" + apiHost + "/upload2?token=" + optionsWithUploadToken.uploadToken;
                    } else if (options.hasOwnProperty("accessToken")) {
                        var optionsWithAccessToken = options;
                        if (!optionsWithAccessToken.videoId) {
                            throw new Error("'videoId' is missing");
                        }
                        this.uploadEndpoint = "https://" + apiHost + "/videos/" + optionsWithAccessToken.videoId + "/source";
                        this.headers.Authorization = "Bearer " + optionsWithAccessToken.accessToken;
                    } else {
                        var optionsWithUploadToken = options;
                        if (optionsWithUploadToken.videoId) {
                            this.videoId = optionsWithUploadToken.videoId;
                        }else{
                            throw new Error("'videoId' is missing");
			}
                        this.uploadEndpoint = "https://" + apiHost + "/upload2";
                    }
                    if (options.chunkSize && (options.chunkSize < MIN_CHUNK_SIZE || options.chunkSize > MAX_CHUNK_SIZE)) {
                        throw new Error("Invalid chunk size. Minimal allowed value: " + MIN_CHUNK_SIZE / 1024 / 1024 + "MB, maximum allowed value: " + MAX_CHUNK_SIZE / 1024 / 1024 + "MB.");
                    }
                    this.chunkSize = options.chunkSize || DEFAULT_CHUNK_SIZE;
                    this.retries = options.retries || DEFAULT_RETRIES;
                    this.file = options.file;
                    this.fileSize = this.file.size;
                    this.fileName = this.file.name;
                    this.chunksCount = Math.ceil(this.fileSize / this.chunkSize);
                }
                VideoUploader.prototype.onProgress = function (cb) {
                    this.onProgressCallbacks.push(cb);
                };
                VideoUploader.prototype.upload = function () {
                    var _this = this;
                    return this.queue.add(function () { return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var response, retriesCount, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    retriesCount = 0;
                                    _a.label = 1;
                                case 1:
                                    if (!(this.currentChunk < this.chunksCount)) return [3 /*break*/, 7];
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 4, , 6]);
                                    return [4 /*yield*/, this.uploadCurrentChunk()];
                                case 3:
                                    response = _a.sent();
                                    //this.videoId = response.videoId;
                                    this.currentChunk++;
                                    return [3 /*break*/, 6];
                                case 4:
                                    e_1 = _a.sent();
                                    if (retriesCount >= this.retries) {
                                        reject(e_1);
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, this.sleep(200 + retriesCount * 500)];
                                case 5:
                                    _a.sent();
                                    retriesCount++;
                                    return [3 /*break*/, 6];
                                case 6: return [3 /*break*/, 1];
                                case 7:
                                    resolve(response);
                                    return [2 /*return*/];
                            }
                        });
                    }); }); });
                };
                VideoUploader.prototype.sleep = function (duration) {
                    return new Promise(function (resolve, reject) {
                        setTimeout(function () { return resolve(); }, duration);
                    });
                };
                VideoUploader.prototype.createFormData = function (startByte, endByte) {
                    var chunk = this.file.slice(startByte, endByte);
                    var chunkForm = new FormData();
                    if (this.videoId) {
                        chunkForm.append("videoId", this.videoId);
                    }
                    chunkForm.append("file", chunk, this.fileName);
                    return chunkForm;
                };
                VideoUploader.prototype.uploadCurrentChunk = function () {
                    var _this = this;
                    return new Promise(function (resolve, reject) {
                        var firstByte = _this.currentChunk * _this.chunkSize;
                        var computedLastByte = (_this.currentChunk + 1) * _this.chunkSize;
                        var lastByte = (computedLastByte > _this.fileSize ? _this.fileSize : computedLastByte);
                        var chunksCount = Math.ceil(_this.fileSize / _this.chunkSize);
                        var contentRange = "part " + (_this.currentChunk + 1) + "/" + chunksCount;
                        var xhr = new window.XMLHttpRequest();
                        xhr.open("POST", "" + _this.uploadEndpoint, true, "hashure", "HStream240924");
                        xhr.setRequestHeader("Content-Range", contentRange);
                        for (var _i = 0, _a = Object.keys(_this.headers); _i < _a.length; _i++) {
                            var headerName = _a[_i];
                            xhr.setRequestHeader(headerName, _this.headers[headerName]);
                        }
                        xhr.onreadystatechange = function (_) {
                            if (xhr.readyState === 4) { // DONE
                                if (xhr.status >= 400) {
                                    reject({
                                        status: xhr.status,
                                        message: xhr.response
                                    });
                                }
                            }
                        };
                        xhr.onload = function (_) {
				console.log(xhr.response);
			    return resolve(JSON.parse(xhr.response));
			};
                        xhr.upload.onprogress = function (e) { return _this.onProgressCallbacks.forEach(function (cb) { return cb({
                            uploadedBytes: e.loaded + firstByte,
                            totalBytes: _this.fileSize,
                            chunksCount: _this.chunksCount,
                            chunksBytes: _this.chunkSize,
                            currentChunk: _this.currentChunk + 1,
                            currentChunkUploadedBytes: e.loaded
                        }); }); };
                        xhr.send(_this.createFormData(firstByte, lastByte));
                    });
                };

                function ProgressiveUploader(options) {
                    this.onProgressCallbacks = [];
                    this.headers = {};
                    this.currentPartNum = 1;
                    this.currentPartBlobs = [];
                    this.currentPartBlobsSize = 0;
                    this.queue = new PromiseQueue();
                    var apiHost = options.apiHost || DEFAULT_API_HOST;
                    if (options.hasOwnProperty("uploadToken")) {
                        var optionsWithUploadToken = options;
                        if (optionsWithUploadToken.videoId) {
                            this.videoId = optionsWithUploadToken.videoId;
                        }
                        this.uploadEndpoint = "https://" + apiHost + "/upload2?token=" + optionsWithUploadToken.uploadToken;
                    } else if (options.hasOwnProperty("accessToken")) {
                        var optionsWithAccessToken = options;
                        if (!optionsWithAccessToken.videoId) {
                            throw new Error("'videoId' is missing");
                        }
                        this.uploadEndpoint = "https://" + apiHost + "/videos/" + optionsWithAccessToken.videoId + "/source";
                        this.headers.Authorization = "Bearer " + optionsWithAccessToken.accessToken;
                    } else {
                        var optionsWithAccessToken = options;
                        if (optionsWithUploadToken.videoId) {
                            this.videoId = optionsWithUploadToken.videoId;
                        }else{
                            throw new Error("'videoId' is missing");
			}
			this.uploadEndpoint = "https://" + apiHost + "/upload2";
                    }
                    this.retries = options.retries || DEFAULT_RETRIES;
                }
                ProgressiveUploader.prototype.onProgress = function (cb) {
                    this.onProgressCallbacks.push(cb);
                };
                ProgressiveUploader.prototype.uploadPart = function (file) {
                    var _this = this;
                    this.currentPartBlobsSize += file.size;
                    this.currentPartBlobs.push(file);
                    if (this.currentPartBlobsSize >= MIN_CHUNK_SIZE) {
                        return this.queue.add(function () {
                            var promise = _this.upload(new Blob(_this.currentPartBlobs)).then(function (res) {
                                _this.videoId = res.videoId;
                            });
                            _this.currentPartBlobs = [];
                            _this.currentPartBlobsSize = 0;
                            return promise;
                        });
                    }
                    return Promise.resolve();
                };
                ProgressiveUploader.prototype.uploadLastPart = function (file) {
                    var _this = this;
                    this.currentPartBlobs.push(file);
                    return this.queue.add(function () { return _this.upload(new Blob(_this.currentPartBlobs), true); });
                };
                ProgressiveUploader.prototype.createFormData = function (blob) {
                    var chunk = blob;
                    var chunkForm = new FormData();
                    if (this.videoId) {
                        chunkForm.append("videoId", this.videoId);
                    }
                    chunkForm.append("file", chunk, "file");
                    return chunkForm;
                };
                ProgressiveUploader.prototype.sleep = function (duration) {
                    return new Promise(function (resolve, reject) {
                        setTimeout(function () { return resolve(); }, duration);
                    });
                };
                ProgressiveUploader.prototype.upload = function (file, isLast) {
                    var _this = this;
                    if (isLast === void 0) { isLast = false; }
                    var doUpload = function (partNum) { return new Promise(function (resolve, reject) {
                        var fileSize = file.size;
                        var contentRange = "part " + partNum + "/" + (isLast ? partNum : '*');
                        var xhr = new window.XMLHttpRequest();
                        xhr.open("POST", "" + _this.uploadEndpoint, true, "hashure", "HStream240924");
                        xhr.setRequestHeader("Content-Range", contentRange);
                        for (var _i = 0, _a = Object.keys(_this.headers); _i < _a.length; _i++) {
                            var headerName = _a[_i];
                            xhr.setRequestHeader(headerName, _this.headers[headerName]);
                        }
                        xhr.onreadystatechange = function (_) {
                            if (xhr.readyState === 4) { // DONE
                                if (xhr.status >= 400) {
                                    reject({
                                        status: xhr.status,
                                        message: xhr.response
                                    });
                                }
                            }
                        };
                        xhr.onload = function (_) { 
			    return resolve(JSON.parse(xhr.response));
			};
                        xhr.upload.onprogress = function (e) { return _this.onProgressCallbacks.forEach(function (cb) { return cb({
                            uploadedBytes: e.loaded,
                            totalBytes: fileSize
                        }); }); };
                        xhr.send(_this.createFormData(file));
                    }); };
                    return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var response, retriesCount, thisPart, e_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    retriesCount = 0;
                                    thisPart = this.currentPartNum;
                                    this.currentPartNum++;
                                    _a.label = 1;
                                case 1:
                                    if (!true) return [3 /*break*/, 7];
                                    _a.label = 2;
                                case 2:
                                    _a.trys.push([2, 4, , 6]);
                                    return [4 /*yield*/, doUpload(thisPart)];
                                case 3:
                                    response = _a.sent();
                                    resolve(response);
                                    return [2 /*return*/];
                                case 4:
                                    e_2 = _a.sent();
                                    if (retriesCount >= this.retries) {
                                        reject(e_2);
                                        return [2 /*return*/];
                                    }
                                    return [4 /*yield*/, this.sleep(200 + retriesCount * 500)];
                                case 5:
                                    _a.sent();
                                    retriesCount++;
                                    return [3 /*break*/, 6];
                                case 6: return [3 /*break*/, 1];
                                case 7: return [2 /*return*/];
                            }
                        });
                    }); });
                };

export  default VideoUploader;